import { colors } from '@/styles'
import Status from './status'
import ErrorIcon from '../document-status-icons/error-icon.svg?react'
import PendingSentIcon from '../document-status-icons/pending-sent-icon.svg?react'
import DraftIcon from '../document-status-icons/draft-icon.svg?react'
import SignedIcon from '../document-status-icons/signed-icon.svg?react'
import PendingIcon from '../document-status-icons/pending-icon.svg?react'

export const DOCUMENT_STATUS = {
  draft: (
    <Status
      text="Draft"
      backgroundColor="#FFFBD8"
      color="#8C7317"
      icon={<DraftIcon fill="#8C7317" />}
    />
  ),
  created: (
    <Status
      text="Draft"
      backgroundColor="#FFFBD8"
      color="#8C7317"
      icon={<DraftIcon fill="#8C7317" />}
    />
  ),
  sent: (
    <Status
      text="Pending"
      backgroundColor={colors.blue88}
      color="#1D415E"
      icon={<PendingSentIcon fill="#1D415E" />}
    />
  ),
  signed: (
    <Status
      text="Complete"
      backgroundColor={colors.green88}
      color={colors.green24}
      icon={<SignedIcon fill="#00A38B" />}
    />
  ),
  error: (
    <Status
      text="Error"
      backgroundColor={colors.red96}
      color={colors.red40}
      icon={<ErrorIcon fill={colors.red40} />}
    />
  )
}

export const SIGNATURE_STATUS = {
  signed: (
    <Status
      text="Signed"
      backgroundColor={colors.green96}
      color="#00A38B"
      icon={<SignedIcon fill="#00A38B" />}
    />
  ),
  pending: (
    <Status
      text="Pending"
      backgroundColor="#FFFBD8"
      color="#8C7317"
      icon={<PendingIcon fill="#8C7317" />}
    />
  ),
  not_required: (
    <Status
      text="Pending"
      backgroundColor="#FFFBD8"
      color="#8C7317"
      icon={<PendingIcon fill="#8C7317" />}
    />
  ),
  unspecified: <Status text="Unspecified" backgroundColor={colors.grey96} color={colors.grey56} />
}
